export default __webpack_public_path__ + "static/media/logo_big.79043d25.png";